
import axios from 'axios';
import { UPDATE_TIMEZONE  } from './types'

export const updateTimezone = (tz) => {
    return {
      type: UPDATE_TIMEZONE,
      payload: tz
    }
  }